module.exports = __webpack_public_path__ + "static/media/hero-image-3.79f429ac.png";